var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.i18nOptions=void 0;
var _en=_interopRequireDefault(require("@24i/prd-localization-files-experienceapp/dist/en.json"));
var _es=_interopRequireDefault(require("@24i/prd-localization-files-experienceapp/dist/es.json"));
var _fr=_interopRequireDefault(require("@24i/prd-localization-files-experienceapp/dist/fr.json"));
var _de=_interopRequireDefault(require("@24i/prd-localization-files-experienceapp/dist/de.json"));
var _he=_interopRequireDefault(require("@24i/prd-localization-files-experienceapp/dist/he.json"));
var _pt=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/pt.json"));
var _bo=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/bo.json"));
var _th=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/th.json"));
var _tr=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/tr.json"));
var _ps=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ps.json"));
var _prs=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/prs.json"));
var _my=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/my.json"));
var _uk=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/uk.json"));
var _id=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/id.json"));
var _ur=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ur.json"));
var _ko=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ko.json"));
var _fa=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/fa.json"));
var _zh=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/zh.json"));
var _ru=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/ru.json"));
var _vi=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/vi.json"));
var _sw=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/sw.json"));
var _pbt=_interopRequireDefault(require("@24i/prd-localization-files-base/dist/pbt.json"));

var i18nOptions={
resources:{
en:{sott:_en.default},
es:{sott:_es.default},
fr:{sott:_fr.default},
de:{sott:_de.default},
he:{sott:_he.default},
pt:{sott:_pt.default},
bo:{sott:_bo.default},
th:{sott:_th.default},
tr:{sott:_tr.default},
ps:{sott:_ps.default},
prs:{sott:_prs.default},
my:{sott:_my.default},
uk:{sott:_uk.default},
id:{sott:_id.default},
ur:{sott:_ur.default},
ko:{sott:_ko.default},
fa:{sott:_fa.default},
zh:{sott:_zh.default},
ru:{sott:_ru.default},
sw:{sott:_sw.default},
vi:{sott:_vi.default},
pbt:{sott:_pbt.default}
},
react:{
useSuspense:false
},
fallbackLng:'en'
};exports.i18nOptions=i18nOptions;